import { render, staticRenderFns } from "./globalMenu.vue?vue&type=template&id=8d6e8afa&scoped=true&"
import script from "./globalMenu.vue?vue&type=script&lang=js&"
export * from "./globalMenu.vue?vue&type=script&lang=js&"
import style0 from "./globalMenu.vue?vue&type=style&index=0&id=8d6e8afa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6e8afa",
  null
  
)

export default component.exports